import { ActionButton } from '../../components/vertical-dot/popper';

export const RoleMappingHeader = ({
  actions,
  tableActions,
}: {
  actions: any;
  tableActions: any;
}): any[] => {
  const newActions = [
    ...(actions || []),
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      isSubHeader: false,
      renderCell: true,
      hideOnSubRows: true,
      Cell: ({ row }: any) => {
        return (
          <td>
            <ActionButton
              actions={tableActions}
              id={row?.leafRows?.[0].original.companyId?.toString()}
              rowData={row?.leafRows?.[0].original}
              counter={parseInt(row?.leafRows?.[0].original.companyId?.toString())}
            />
          </td>
        );
      },
    },
  ];

  return newActions;

  return [
    {
      Header: 'Source Company',
      accessor: 'sourceCompanyName',
      width: 150,
      sortable: false,
    },
    {
      Header: 'Source Role',
      accessor: 'sourceRoleName',
      width: 150,
      sortable: false,
    },
    {
      Header: 'Destination Company',
      accessor: 'destinationCompanyName',
      width: 150,
      sortable: false,
    },

    {
      Header: 'Destination Role',
      accessor: 'destinationRoleName',
      width: 150,
      sortable: false,
    },
    {
      Header: '',
      accessor: 'actions',
      width: 80,
      sortable: false,
      Cell: ({ row }: any) => {
        return (
          <div>
            {
              <ActionButton
                actions={tableActions}
                id={row.original.publishId}
                rowData={row.original}
                counter={parseInt(row?.id)}
              />
            }
          </div>
        );
      },
    },
  ];
};
